module.exports = __webpack_public_path__ + "braveuistatic/img/apps/www.bravenet.com/src/assets/img/messageforums/bravenet_messageforums_personalization.png";